<template>
    <div
        :class="{ 'is--preview': layoutType === 'previewLayout' }"
        class="app-navbar-wrapper"
        data-testid="app-navbar-wrapper"
    >
        <nav class="app-navbar py-3 h-16 w-full flex lg:flex-row lg:items-center lg:justify-between" data-testid="navbar-main">
            <div
                v-if="isDesktop"
                class="app-navbar__logo flex items-center justify-center"
                data-testid="navbar-logo-container"
            >
                <RouterLink
                    :to="mainPageUrl"
                    class="outline-none"
                    data-testid="navbar-link-home"
                >
                    <img
                        :src="getLogo"
                        alt="Logo"
                        data-testid="navbar-logo"
                        class="h-9 w-auto max-w-48 object-contain"
                    >
                </RouterLink>
            </div>
            <div
                class="flex-grow flex items-center gap-1 lg:gap-3 px-1 lg:px-6 xl:px-8"
                data-testid="navbar-menu-section"
            >
                <RedesignAccountMenu
                    v-if="layoutType === 'activeLayout' || isReportPage"
                    data-testid="navbar-menu-account"
                    :edit-mode="editMode"
                />
                <RedesignDashboardMenu
                    v-if="layoutType === 'activeLayout'"
                    data-testid="navbar-menu-dashboard"
                    :edit-mode="editMode"
                />
                <RedesignManageReports
                    v-if="isDesktop"
                    data-testid="navbar-menu-reports"
                    :edit-mode="editMode"
                />
            </div>
            <div class="flex items-center justify-end gap-2 lg:gap-3 xl:gap-5" data-testid="navbar-actions">
                <SoundNotifications v-if="isDesktop" data-testid="navbar-sound-notifications" />
                <RedesignLanguageSwitcher
                    data-testid="navbar-language-switcher"
                    :disabled="layoutType=== 'previewLayout'"
                />
                <slot
                    v-if="isDesktop"
                    name="dashboard-operations"
                />
            </div>
        </nav>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import RedesignAccountMenu from '@/components/RedesignComponents/Navbar/RedesignAccountMenu.vue'
import RedesignDashboardMenu from '@/components/RedesignComponents/Navbar/RedesignDashboardMenu.vue'
import RedesignManageReports from '@/components/RedesignComponents/Navbar/RedesignManageReports.vue'
import RedesignLanguageSwitcher from '@/components/RedesignComponents/Navbar/RedesignLanguageSwitcher.vue'
import { isDesktop } from '@/composables/useBreakpoints'
import { activeLayoutLogo } from '@/composables/globalData/useLayouts'
import SoundNotifications from '@/components/RedesignComponents/Navbar/SoundNotifications.vue'
import { isPreviewLayout, previewLayoutLogo } from '@/composables/usePreviewLayout'
import { useRoute } from 'vue-router/composables'
const route = useRoute()

/* Props */
interface IProps {
    editMode?: boolean
    isReportPage?: boolean
    layoutType?: 'previewLayout' | 'activeLayout'
}

const props = defineProps<IProps>()

/* Computed */
const getLogo = computed(() => {
    if (props.layoutType === 'previewLayout' && isPreviewLayout.value) {
        return String(previewLayoutLogo.value)
    }
    return String(activeLayoutLogo.value) || ''
})

const mainPageUrl = computed(() => {
    const token = route.query.token
    return { path: '/', query: { token } }
})

</script>

<style lang="scss">
.app-navbar {
    &-wrapper {
        @apply px-1 lg:px-8 xl:px-10 block border-b border-ui-lines;
        background: var(--dashboardHeaderBgColor-color);

        &.is--preview {
            .el-input__suffix-inner {
                pointer-events: none !important;
            }
        }
    }

    &:not(.is--preview) {
        z-index: var(--index-navbar);
    }

}
</style>
